import {
  Grid,
  Typography,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';
import { Colors, isLightTheme } from '../config/default';
import { supportingDocumentsPopup } from '../constants/appConstants';

function PoLineitems({ supportindDocLineitems }) {
  const { DESCRIPTION, PO_LINEITEMS, AMOUNT, RECIEVED, REMAINING } = supportingDocumentsPopup;
  const header = [DESCRIPTION, AMOUNT, RECIEVED, REMAINING];
  const rowText = isLightTheme() ? Colors.TEXTGREY : '#ccc';
  const rowStyle = { color: rowText, textAlign: 'center', fontSize: '10px' };
  return (
    <Grid item xs={12} md={4}>
      <Box
        sx={{
          p: 2,
          backgroundColor: Colors.NAV_BLACK,
          borderRadius: 2,
          height: '65vh'
        }}>
        <Typography sx={{ color: Colors.TOURQUISE, mb: '.5rem' }}>{PO_LINEITEMS}</Typography>
        <Box
          sx={{
            p: 2,
            backgroundColor: isLightTheme() ? Colors.BG_BLACK : Colors.NAV_BLACK,
            borderRadius: 2,
            height: { xs: '47vh', md: '57vh', xl: '42vh' },
            overflowY: 'auto'
          }}>
          <Table size="small" sx={{ width: '100%', tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                {header?.map((item) => {
                  return (
                    <TableCell>
                      <Typography sx={{ fontWeight: 400, color: Colors.WHITE, fontSize: '.8em' }}>
                        {item}
                      </Typography>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {supportindDocLineitems?.map((item, idx) => (
                <TableRow key={idx} hover>
                  <TableCell sx={{ color: rowText, fontSize: '10px' }}>
                    {item.find((i) => i.name === 'Description')?.value || '-'}
                  </TableCell>
                  <TableCell sx={rowStyle}>
                    {item.find((i) => i.name === 'Amount')?.value || '-'}
                  </TableCell>
                  <TableCell sx={rowStyle}>
                    {item.find((i) => i.name === 'Received Amount')?.value || '-'}
                  </TableCell>
                  <TableCell sx={rowStyle}>
                    {item.find((i) => i.name === 'Remaining Amount')?.value || '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Grid>
  );
}

export default PoLineitems;
